import React, { Component } from "react";
import { Link } from "react-router-dom";

class ClaimCreateOverseasTravel extends Component {
  render() {
    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 22 }}>
          <h4 style={{ margin: 0, fontWeight: 900, color: "#0F172A" }}>
            Create Overseas Travel Claim
          </h4>
          <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
            Claim expenses for approved international business travel.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 22 }}>
          <div>
            <div style={card}>
              <h5 style={sectionTitle}>Overseas Travel Information</h5>

              <div style={grid4}>
                {this.renderInput("Employee Name *", "Siti Nur Aisyah Binti Ahmad")}
                {this.renderInput("Employee ID", "EMP-2024-0088", true)}
                {this.renderInput("Department *", "Data & Analytics")}
                {this.renderInput("Related Trip Ref", "TR-2024-0079")}
                {this.renderInput("Travel Purpose *", "Regional conference")}
                {this.renderInput("Travel Period *", "10 May 2024 - 15 May 2024")}
                {this.renderInput("Origin *", "Kuching, Malaysia")}
                {this.renderInput("Destination *", "Singapore")}
                {this.renderInput("Currency", "SGD / MYR")}
                {this.renderInput("Exchange Rate", "3.50")}
                {this.renderInput("Passport No.", "A12345678")}
                {this.renderInput("Approval Ref.", "BUD-2024-0039")}
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Overseas Expense Items</h5>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#F8FAFC" }}>
                    {[
                      "#",
                      "Date",
                      "Category",
                      "Description",
                      "Foreign Amount",
                      "Currency",
                      "Amount (RM)",
                      "Receipt",
                      "Action",
                    ].map((h) => (
                      <th key={h} style={thStyle}>{h}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {[
                    ["1", "10 May 2024", "Flight", "Return flight ticket KCH - SIN", "680.00", "MYR", "680.00", "Uploaded"],
                    ["2", "11 May 2024", "Accommodation", "Hotel stay in Singapore, 4 nights", "950.00", "SGD", "3,325.00", "Uploaded"],
                    ["3", "12 May 2024", "Transport", "Airport transfer and local transport", "120.00", "SGD", "420.00", "Uploaded"],
                    ["4", "13 May 2024", "Meal", "Daily meal allowance", "300.00", "SGD", "1,050.00", "N/A"],
                    ["5", "14 May 2024", "Visa / Admin", "Travel insurance and admin fee", "205.00", "MYR", "205.00", "Uploaded"],
                    ["6", "Select date", "Select category", "Enter description", "0.00", "Currency", "0.00", "Upload"],
                  ].map((row) => (
                    <tr key={row[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                      <td style={tdStyle}>{row[0]}</td>
                      <td style={tdStyle}><input value={row[1]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[2]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[3]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[4]} readOnly style={{ ...tableInput, textAlign: "right" }} /></td>
                      <td style={tdStyle}><input value={row[5]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[6]} readOnly style={{ ...tableInput, textAlign: "right" }} /></td>
                      <td style={tdStyle}>{this.renderReceiptStatus(row[7])}</td>
                      <td style={tdStyle}><button style={deleteButton}>🗑</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button style={{ ...secondaryButton, marginTop: 14 }}>+ Add Overseas Expense</button>

              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 14, marginTop: 18 }}>
                <div style={{ fontWeight: 900 }}>TOTAL OVERSEAS TRAVEL CLAIM (RM)</div>
                <div style={totalBox}>5,680.00</div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Supporting Documents</h5>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
                <div style={uploadBox}>
                  <div style={{ fontSize: 30 }}>☁</div>
                  <div style={{ marginTop: 8, color: "#64748B" }}>
                    Drag and drop travel documents here, or <b>click to browse</b>
                  </div>
                  <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 6 }}>
                    Passport copy, approval, tickets, receipts. PDF, JPG, PNG up to 10MB each.
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: 900, marginBottom: 10 }}>Uploaded Documents (5)</div>
                  {[
                    "Trip_Approval_TR-2024-0079.pdf",
                    "Flight_Ticket_KCH_SIN.pdf",
                    "Hotel_Invoice_Singapore.pdf",
                    "Transport_Receipts_SIN.pdf",
                    "Travel_Insurance.pdf",
                  ].map((file) => (
                    <div key={file} style={fileRow}>
                      <span>{file}</span>
                      <span style={{ color: "#94A3B8" }}>×</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Declaration</h5>

              <label style={{ display: "flex", gap: 10, fontSize: 13, color: "#334155" }}>
                <input type="checkbox" defaultChecked />
                I confirm that all overseas travel expenses were incurred for approved official business travel.
              </label>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, marginTop: 18 }}>
                {this.renderInput("Signature of Employee", "Siti Nur Aisyah Binti Ahmad")}
                {this.renderInput("Date", "20 May 2024")}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 18 }}>
              <Link to="/claim/create" style={secondaryLink}>Back</Link>
              <div style={{ display: "flex", gap: 10 }}>
                <button style={secondaryButton}>Save Draft</button>
                <button style={primaryButton}>Submit Claim ›</button>
              </div>
            </div>
          </div>

          <div>
            <div style={sideCard}>
              <h5 style={sectionTitle}>Claim Summary</h5>
              {this.renderSideRow("Related Trip", "TR-2024-0079")}
              {this.renderSideRow("Destination", "Singapore")}
              {this.renderSideRow("Travel Duration", "6 days")}
              {this.renderSideRow("Exchange Rate", "1 SGD = RM 3.50")}
              {this.renderSideRow("Total Amount", "RM 5,680.00")}
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Document Check</h5>
              <div style={checkRow}>✓ Trip approval attached</div>
              <div style={checkRow}>✓ Flight ticket attached</div>
              <div style={checkRow}>✓ Hotel invoice attached</div>
              <div style={checkRow}>✓ Travel insurance attached</div>
              <div style={checkRow}>✓ Overseas receipts attached</div>
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Overseas Claim Notes</h5>
              <ul style={sideText}>
                <li>Foreign currency claims must include exchange rate reference.</li>
                <li>Travel must match approved budget and itinerary.</li>
                <li>Receipts are required for transport, hotel and other expenses.</li>
                <li>Allowance items should follow company overseas travel policy.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderReceiptStatus(status) {
    const map = {
      Uploaded: ["#ECFDF3", "#027A48"],
      "N/A": ["#F1F5F9", "#475569"],
      Upload: ["#FFF7E6", "#B76E00"],
    };

    const [bg, color] = map[status] || map.Upload;

    return (
      <span
        style={{
          background: bg,
          color,
          padding: "5px 10px",
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 900,
        }}
      >
        {status}
      </span>
    );
  }

  renderInput(label, value, disabled = false) {
    return (
      <div>
        <label style={labelStyle}>{label}</label>
        <input value={value} readOnly disabled={disabled} style={inputStyle} />
      </div>
    );
  }

  renderSideRow(label, value) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
        <span style={{ color: "#64748B", fontSize: 13 }}>{label}</span>
        <b style={{ color: "#0F172A", fontSize: 13 }}>{value}</b>
      </div>
    );
  }
}

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginBottom: 16,
};

const sideCard = {
  ...card,
  marginBottom: 16,
};

const sectionTitle = {
  margin: "0 0 16px",
  fontWeight: 900,
  color: "#0F172A",
};

const grid4 = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 800,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 38,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
  background: "#fff",
};

const thStyle = {
  padding: "10px 12px",
  textAlign: "left",
  fontWeight: 900,
  fontSize: 12,
  color: "#334155",
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: 8,
  fontSize: 13,
  color: "#334155",
};

const tableInput = {
  width: "100%",
  height: 34,
  border: "1px solid #E5E7EB",
  borderRadius: 6,
  padding: "0 10px",
  fontSize: 12,
  background: "#fff",
};

const totalBox = {
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 16px",
  minWidth: 170,
  textAlign: "right",
  fontWeight: 900,
  fontSize: 18,
};

const uploadBox = {
  border: "1px dashed #CBD5E1",
  borderRadius: 12,
  padding: 28,
  textAlign: "center",
  color: "#334155",
};

const fileRow = {
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "10px 12px",
  marginBottom: 8,
  display: "flex",
  justifyContent: "space-between",
  fontSize: 13,
};

const deleteButton = {
  border: "1px solid #FECACA",
  color: "#DC111C",
  background: "#fff",
  borderRadius: 6,
  width: 32,
  height: 32,
};

const primaryButton = {
  background: "#DC111C",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "11px 22px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 18px",
  fontWeight: 800,
};

const secondaryLink = {
  ...secondaryButton,
  textDecoration: "none",
};

const sideText = {
  color: "#64748B",
  fontSize: 13,
  lineHeight: "22px",
  paddingLeft: 18,
};

const checkRow = {
  color: "#027A48",
  fontSize: 13,
  fontWeight: 800,
  marginBottom: 10,
};

export default ClaimCreateOverseasTravel;